import React from "react"

import { ContentTag, Obj, connect } from "scrivito"

interface ScrivitoPageTitleProps {
  page?: Obj | null | undefined
}

function ScrivitoPageTitleComponent({ page }: ScrivitoPageTitleProps) {
  return page ? <ContentTag content={page} attribute="title" tag="h1" /> : null
}

export const ScrivitoPageTitle = React.memo(
  connect(ScrivitoPageTitleComponent)
) as typeof ScrivitoPageTitleComponent
